import React, { useState } from "react";
import tw from "twin.macro";
import FooterLogo from "../Images/logo.png";
import SocialIcon from "./SocialIcons/SocialIcon";
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { FiMail } from 'react-icons/fi';
import { SlSocialFacebook } from 'react-icons/sl';

const PrimaryButton = tw.a`mb-8 md:mb-0 px-6 py-1 text-lg inline-flex justify-center items-center cursor-pointer text-black border-2 border-blue-300 hocus:text-blue-300 duration-200`;


const Container = tw.div`absolute bottom-0 text-white text-center border-t border-white `;
const FooterContainer = tw.div`px-4 md:px-0 md:py-14 items-center md:w-full  md:justify-center md:flex text-left mt-10`;

const FlexContainer = tw.div` md:flex md:w-full md:mx-72   justify-around`;
const VerticalSectionOne = tw.div`md:w-3/12   grid grid-cols-1 content-start mr-20`;
const VerticalSectionTwo = tw.div`md:w-3/12 my-10 md:my-0 grid grid-cols-1 content-start `;
const VerticalSectionThree = tw.div` relative md:w-3/12  grid grid-cols-1 content-start `;


const Heading = tw.div`font-semibold md:text-xl`;
const Paragraph = tw.div` text-base opacity-75 my-2`;
const Subheading = tw.div`text-lg opacity-75 my-1`;
const YellowSubheading = tw.div`md:text-lg opacity-75 my-1  text-yellow-400  hocus:text-blue-300 duration-500 cursor-pointer`;
const FooterHeading = tw.div`text-smm py-2 bg-secondary border-t`;

const SocialIconContainer = tw.div`flex items-center my-4`
const SocialIcons = tw.a` hocus:text-blue-300 duration-200`
const BottomContainer = tw.div`flex`;

export default () => {
  return (
    <Container className="footer">

      <FooterContainer>
        <FlexContainer>
          <VerticalSectionOne>
            <img src={FooterLogo} width="80%" />
            <Paragraph>
              We bring the years, global experience, and stamina to guide our
              clients through new and often disruptive realities.
            </Paragraph>
          </VerticalSectionOne>
          <VerticalSectionTwo>
            <YellowSubheading> gagansahi@drywall.com</YellowSubheading>

            <YellowSubheading>+1 (431) 335-3993</YellowSubheading>
            <div>
              <br />
            </div>
            <Subheading>13 Pipe line, Winnipeg, Manitoba</Subheading>
          </VerticalSectionTwo>

          <VerticalSectionThree>

            {/* <SocialIcon /> */}

            <div class="footer-social-icon">
              <span>Follow us</span>
              <SocialIconContainer>
                <SocialIcons href="mailto:gusaindishant001@gmail.com"><FiMail size={28} /></SocialIcons>
                <SocialIcons href="https://www.facebook.com/sahi.gagan.5/" target="_blank"><SlSocialFacebook size={24} /></SocialIcons>
                <SocialIcons href="https://www.instagram.com/gagan__sahi/" target="_blank" ><FaInstagram size={28} /></SocialIcons>
              </SocialIconContainer>

              <PrimaryButton href="/ContactUs">GET IN TOUCH</PrimaryButton>
            </div>

          </VerticalSectionThree>
        </FlexContainer>
      </FooterContainer>
      <FooterHeading>
        Singh Drywall LLP © Copyrights 2023. All Rights Reserved.
      </FooterHeading>
    </Container>
  );
};
